import { autoinject } from 'aurelia-framework';
import { ListBaseView } from 'General/Views/Dynamic/List/ListBaseView';

@autoinject
export class ListView extends ListBaseView { }